import { Layout } from './types';

const _layoutMap: Map<string, Layout> = new Map();

export const getLayoutByName = (name: string): Layout => _layoutMap.get(name.toLowerCase());

export const defineLayout = (name: string, strategy: Layout) => {
  _layoutMap.set(name.toLowerCase(), strategy);
};

export const componentRenderer = (hierarchy, getComponentCallback) => name => {
  const components = (hierarchy && hierarchy[name]) || [];

  return components.map(getComponentCallback);
};

export const renderAll = (hierarchy, getComponentCallback) => {
  const sections = Object.keys(hierarchy);
  const allContent = sections.reduce((summ, name) => [...summ, ...hierarchy[name]], []);

  return allContent.map(getComponentCallback);
};
